<template>
    <v-container id="contact-section">
        <v-row>
            <v-col cols="12" class="text-center">
                <h2 class="display-1 font-weight-bold mb-6">Contáctanos</h2>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6" offset-md="3">
                <!-- <v-form @submit.prevent="submitForm">
                    <v-text-field v-model="name" label="Nombre" required></v-text-field>
                    <v-text-field v-model="email" label="Email" required :rules="emailRules"></v-text-field>
                    <v-textarea v-model="message" label="Mensaje" required></v-textarea>
                    <v-btn type="submit" color="primary" large>Enviar</v-btn>
                </v-form> -->
                <div class="contact-form">
                    <h2>Formulario de Contacto</h2>

                    <form @submit.prevent="submitForm">
                        <!-- Campos del formulario -->
                        <div class="form-group">
                            <label for="name">Nombre:</label>
                            <input id="name" v-model="form.name" type="text" required>
                        </div>

                        <div class="form-group">
                            <label for="email">Email:</label>
                            <input id="email" v-model="form.email" type="email" required>
                        </div>

                        <div class="form-group">
                            <label for="message">Mensaje:</label>
                            <textarea id="message" v-model="form.message" rows="5" required></textarea>
                        </div>

                        <!-- Contenedor vacío para reCAPTCHA -->
                        <div id="recaptcha-container" class="g-recaptcha"></div>

                        <button type="submit" :disabled="loading">
                            {{ loading ? 'Enviando...' : 'Enviar' }}
                        </button>

                        <div v-if="message" :class="['alert', message.type]">
                            {{ message.text }}
                        </div>
                    </form>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            form: {
                name: '',
                email: '',
                message: '',
                'g-recaptcha-response': ''
            },
            loading: false,
            recaptchaVerified: false,
            message: null,
            recaptchaWidgetId: null
        };
    },
    mounted() {
        this.initializeRecaptcha();
    },
    beforeUnmount() {
        // Limpiar reCAPTCHA al destruir el componente
        if (window.grecaptcha && this.recaptchaWidgetId !== null) {
            window.grecaptcha.reset(this.recaptchaWidgetId);
        }
    },
    methods: {
        async initializeRecaptcha() {
            // 1. Verificar entorno para usar clave de prueba o producción
            this.recaptchaSiteKey = window.location.hostname === 'localhost'
                ? '6Ld-KWwrAAAAAEt7TNHEK_5JXctFCC134fxUgqO-' // Clave de prueba para desarrollo
                : '6Ld-KWwrAAAAAEt7TNHEK_5JXctFCC134fxUgqO-'; // Reemplazar con tu clave real

            // 2. Cargar script dinámicamente
            await this.loadRecaptchaScript();

            // 3. Renderizar después de asegurar que está cargado
            this.renderRecaptcha();
        },
        loadRecaptchaScript() {
            return new Promise((resolve) => {
                if (window.grecaptcha) {
                    resolve();
                    return;
                }

                const script = document.createElement('script');
                script.src = `https://www.google.com/recaptcha/api.js?render=explicit&onload=vueRecaptchaLoaded`;
                script.async = true;
                script.defer = true;

                window.vueRecaptchaLoaded = resolve;

                document.head.appendChild(script);
            });
        },
        renderRecaptcha() {
            window.grecaptcha.ready(() => {
                try {
                    window.grecaptcha.render('recaptcha-container', {
                        sitekey: this.recaptchaSiteKey,
                        callback: this.recaptchaCallback,
                        'expired-callback': this.recaptchaExpired,
                        'error-callback': this.recaptchaError
                    });
                    this.recaptchaLoaded = true;
                } catch (error) {
                    console.error('Error al renderizar reCAPTCHA:', error);
                    this.handleRecaptchaError();
                }
            });
        },
        handleRecaptchaError() {
            // Mostrar mensaje al usuario o intentar recargar
            console.error('Por favor verifica tu clave reCAPTCHA');
            // Opcional: recargar después de 5 segundos
            setTimeout(() => {
                window.location.reload();
            }, 5000);
        },
        // loadRecaptcha() {
        //     // Verificar si el script ya está cargado
        //     if (window.grecaptcha) {
        //         this.initRecaptcha();
        //         return;
        //     }

        //     // Cargar script de reCAPTCHA
        //     const script = document.createElement('script');
        //     script.src = 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaLoaded&render=explicit';
        //     script.async = true;
        //     script.defer = true;

        //     // Configurar callback global
        //     window.vueRecaptchaLoaded = () => {
        //         this.initRecaptcha();
        //     };

        //     document.head.appendChild(script);
        // },
        // initRecaptcha() {
        //     // Asegurarse de que el contenedor existe y está vacío
        //     const container = document.getElementById('recaptcha-container');
        //     if (!container) {
        //         console.error('Contenedor de reCAPTCHA no encontrado');
        //         return;
        //     }

        //     // Limpiar el contenedor por si acaso
        //     container.innerHTML = '';

        //     // Inicializar reCAPTCHA
        //     this.recaptchaWidgetId = window.grecaptcha.render('recaptcha-container', {
        //         sitekey: '6LecH2wrAAAAAI4TIzoC1H2MPLtMhn29_sDkE11n', // Reemplaza con tu clave
        //         callback: (response) => {
        //             this.recaptchaVerified = true;
        //             this.form['g-recaptcha-response'] = response;
        //         },
        //         'expired-callback': () => {
        //             this.recaptchaVerified = false;
        //             this.form['g-recaptcha-response'] = '';
        //         },
        //         'error-callback': () => {
        //             this.recaptchaVerified = false;
        //             this.form['g-recaptcha-response'] = '';
        //         }
        //     });
        // },
        async submitForm() {
            // if (!this.recaptchaVerified) {
            //     this.showMessage('Por favor, completa el reCAPTCHA', 'error');
            //     return;
            // }

            this.loading = true;
            this.message = null;

            try {
                const response = await fetch('https://formsubmit.co/ajax/admin@trademasterbots.com', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        ...this.form,
                        _captcha: false,
                        _template: 'table',
                        _next: 'https://tu-dominio.com/gracias.html'
                    })
                });

                const data = await response.json();

                if (response.ok && data.success) {
                    this.showMessage('Mensaje enviado con éxito', 'success');
                    this.resetForm();
                } else {
                    throw new Error(data.message || 'Error al enviar el formulario');
                }
            } catch (error) {
                this.showMessage(error.message || 'Error al enviar el mensaje', 'error');
                console.error('Error:', error);
            } finally {
                this.loading = false;
            }
        },
        resetForm() {
            this.form = {
                name: '',
                email: '',
                message: '',
                'g-recaptcha-response': ''
            };
            this.recaptchaVerified = false;

            // Resetear reCAPTCHA
            if (window.grecaptcha && this.recaptchaWidgetId !== null) {
                window.grecaptcha.reset(this.recaptchaWidgetId);
            }
        },
        showMessage(text, type) {
            this.message = { text, type };
        }
    }
};
</script>

<style scoped>
.contact-form {
    max-width: 600px;
    margin: 0 auto;
    padding: 20px;
    font-family: Arial, sans-serif;
}

h2 {
    color: #2c3e50;
    margin-bottom: 20px;
}

.form-group {
    margin-bottom: 15px;
}

label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
}

input,
textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
}

textarea {
    min-height: 150px;
    resize: vertical;
}

.submit-btn {
    background-color: #42b983;
    color: white;
    border: none;
    padding: 12px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s;
}

.submit-btn:hover {
    background-color: #369f6b;
}

.submit-btn:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
}

.alert {
    margin-top: 20px;
    padding: 10px 15px;
    border-radius: 4px;
}

.success {
    background-color: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
}

.error {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
}

/* Estilos anteriores más estos adicionales */
.g-recaptcha {
    margin: 15px 0;
}

.submit-btn:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
}
</style>